import SectionHeading from "@/components/feature/SectionHeading";
import ArticleCard from "@/components/feature/ArticleCard";
import { getHotReviews } from "@/lib/content";

export default function FeaturedReviews() {
  const reviews = getHotReviews(3);
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 mt-14">
      <SectionHeading
        title="热门车型评测"
        subtitle="精选深度试驾与专业评测，帮助购车决策"
        moreTo="/reviews"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((item) => (
          <ArticleCard key={item.id} article={item} variant="grid" />
        ))}
      </div>
    </section>
  );
}